import { useNavigate } from "react-router-dom";
import { styled } from "@mui/material/styles";
import { Button, Typography, Container, Box } from "@mui/material";
// import Page from "../components/shortComponents/Page";
import LsService, { storageKey } from "../services/localstorage";

const ContentStyle = styled("div")(({ theme }) => ({
  maxWidth: 480,
  margin: "auto",
  display: "flex",
  justifyContent: "center",
  flexDirection: "column",
}));

export default function PageNotFound() {
  const navigate = useNavigate();

  const handleLogout = () => {
    // dispatch(authLogout());
    LsService.removeItem(storageKey);
    navigate('/');
  };

  const handleBack = () => {
    if (window.history.state && window.history.state.idx > 0) {
      navigate(-1);
    } else {
      navigate("/");
    }
  }

  return (
    <Box sx={{width:"100vw", height:"100vh", display:"flex", alignItems:"center"}}>
      <Container>
        <ContentStyle sx={{ textAlign: "center", alignItems: "center" }}>
          <Typography variant="h3" paragraph>
            Sorry, page not found!
          </Typography>

          <Typography sx={{ color: "text.secondary" }}>
            Sorry, we couldn’t find the page you’re looking for. Perhaps you’ve
            mistyped the URL? Be sure to check your spelling.
          </Typography>

          {/* <Box
            component="img"
            src="/static/images/404.png"
            sx={{ height: 300, mx: "auto", my: 1 }}
          /> */}
          <Box p={2}/>
          <div>
            <Button size="large" variant="contained" color="error" onClick={() => handleBack()} sx={{ marginRight: 3 }}>
              Back
            </Button>
            <Button size="large" variant="contained" onClick={() => handleLogout()} >
              Go to Login
            </Button>
          </div>
        </ContentStyle>
      </Container>
    </Box>
  );
}
